//问题产品
import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL
export default {

  //采购返现-收款链接列表
  // 使用组件内的加载状态；业务错误也返回给组件，以便展示失败和重试入口。
  purchaseCashbackList: (data) => apiAxios('post', baseURL + '/purchase.cashback.list', data, { isLoading: true, resolveError: true }),
  //采购返现-创建收款链接，由表单管理提交状态及幂等重试。
  purchaseCashbackCreate: (data) => apiAxios('post', baseURL + '/purchase.cashback.create', data, { isLoading: true, resolveError: true }),
  //采购返现-废弃收款链接，id 为收款主单 ID。
  purchaseCashbackVoid: (data) => apiAxios('post', baseURL + '/purchase.cashback.void', data, { isLoading: true, resolveError: true }),

  //问题产品-所有可选类型
  types: (data) => apiAxios('post', baseURL + '/problem.types', data),
  //问题产品-状态MAP
  statusMap: (data) => apiAxios('post', baseURL + '/problem.statusMap', data),
  //问题产品-添加表单预览数据
  problemStorePreview: (data) => apiAxios('post', baseURL + '/problem.storePreview', data),
  //问题产品-列表 
  problemList: (data) => apiAxios('post', baseURL + '/problem.list', data),
  //问题产品-添加
  problemStore: (data) => apiAxios('post', baseURL + '/problem.store', data),
  //问题产品-详情
  problemDetail: (data) => apiAxios('post', baseURL + '/problem.detail', data),
  //问题产品-业务修改OPTION
  updateOption: (data) => apiAxios('post', baseURL + '/problem.updateOption', data),
  //问题产品-业务翻译
  translate: (data) => apiAxios('post', baseURL + '/problem.translate', data),
  //问题产品-业务决策
  y_deal: (data) => apiAxios('post', baseURL + '/problem.y_deal', data),
  //采购处理 
  g_deal: (data) => apiAxios('post', baseURL + '/problem.g_deal', data),
  //问题产品-确认完成
  p_deal: (data) => apiAxios('post', baseURL + '/problem.p_deal', data),
  //问题产品-修改后数据编辑
  updatePreData: (data) => apiAxios('post', baseURL + '/problem.updatePreData', data),
  //问题产品-业务直接完成
  skipToComplete: (data) => apiAxios('post', baseURL + '/problem.skipToComplete', data),
  //问题产品-退回待业务决策
  backToYdeal: (data) => apiAxios('post', baseURL + '/problem.backToYdeal', data),
  //问题产品-修改临时备注
  updateTempRemark: (data) => apiAxios('post', baseURL + '/problem.updateTempRemark', data),
  //问题产品-问题产品取消
  problemCancel: (data) => apiAxios('post', baseURL + '/problem.cancel', data),
  //问题产品-退回待翻译
  toUnTranslate: (data) => apiAxios('post', baseURL + '/problem.toUnTranslate', data),
  //问题产品-手机上传-保存上传的图片地址
  setMobileUploadImage: (data) => apiAxios('post', 'https://jpapi.rakumart.cn/mobileUpload.setMobileUploadImage', data),
  //问题产品-手机上传查询上传的图片地址
  getMobileUploadImage: (data) => apiAxios('post', baseURL + '/mobileUpload.getMobileUploadImage', data),
  //问题产品-切换图片是否显示给客户看
  switchImageShow: (data) => apiAxios('post', baseURL + '/problem.switchImageShow', data),
  //问题产品-设置退款凭证图片
  updateRefundImage: (data) => apiAxios('post', baseURL + '/problem.updateRefundImage', data),
  //问题产品-审核
  confirmRefundStatus: (data) => apiAxios('post', baseURL + '/problem.confirmRefundStatus', data),
  //问题产品-发送邮件提醒
  problemWaitClient: (data) => apiAxios('post', baseURL + '/problem.problemWaitClient', data),
  //问题产品-替换商品
  saveReplaceGoods: (data) => apiAxios('post', baseURL + '/problem.saveReplaceGoods', data),
  //问题产品-配货直接完成
  distributionDirectComplete: (data) => apiAxios('post', baseURL + '/problem.distributionDirectComplete', data),
}
